import instance from "@/services/api";

export const resetPassword = async (body) => {
  return await instance(false)
    .post("/auth/reset_password/", body)
    .then((res) => res?.data);
};
